import React from 'react';
import './AnimationTest.css';

const AnimationTest = () => {
  return (
    <div className="animation-test">
      <div className="container">
        <h2 className="section-title">Color Animation Test</h2>
        
        <div className="test-grid">
          {/* Gradient Animation Tests */}
          <div className="test-section">
            <h3>Gradient Animations</h3>
            <div className="test-item animate-gradient-primary">Primary Gradient</div>
            <div className="test-item animate-gradient-secondary">Secondary Gradient</div>
            <div className="test-item animate-gradient-accent">Accent Gradient</div>
            <div className="test-item animate-gradient-fast">Fast Gradient</div>
          </div>

          {/* Color Shift Tests */}
          <div className="test-section">
            <h3>Color Shift Animations</h3>
            <div className="test-item animate-color-primary">Primary Color Shift</div>
            <div className="test-item animate-color-secondary">Secondary Color Shift</div>
            <div className="test-item animate-color-accent">Accent Color Shift</div>
            <div className="test-item animate-color-breathe">Color Breathe</div>
          </div>

          {/* Interactive Elements */}
          <div className="test-section">
            <h3>Interactive Elements</h3>
            <button className="btn-primary btn-color-shift animate-button-hover focus-color-ring">
              Primary Button
            </button>
            <button className="btn-secondary btn-color-shift animate-button-hover focus-color-ring">
              Secondary Button
            </button>
            <a href="#" className="test-link link-color-shift animate-link-wave focus-color-ring">
              Animated Link
            </a>
          </div>

          {/* Card Animations */}
          <div className="test-section">
            <h3>Card Animations</h3>
            <div className="test-card card-color-shift animate-card-border">
              <h4>Animated Card</h4>
              <p>This card has color-shifting border and hover effects.</p>
            </div>
          </div>

          {/* Text Animations */}
          <div className="test-section">
            <h3>Text Animations</h3>
            <div className="test-text animate-text-gradient">Gradient Text Animation</div>
            <div className="test-icon animate-icon-rotate">🎨</div>
          </div>
        </div>

        {/* Reduced Motion Test */}
        <div className="reduced-motion-notice">
          <p><strong>Note:</strong> If you have "Reduce Motion" enabled in your system preferences, animations will be disabled for accessibility.</p>
        </div>
      </div>
    </div>
  );
};

export default AnimationTest;